var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('ACADEMICO_GERENCIAMENTO.FECHAMENTO_PERIODO'),"subtitulo":_vm.$t('ACADEMICO.FECHAMENTO_PERIODO_LETIVO_DESCRICAO'),"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }